import { useMemo } from "react";
import Chart from "react-apexcharts";

export default function ChartLine(props) {
    const { data: dataSeries = [{ data: [0, 0] }], formatting = { colorStops: undefined }, isResizing = false } = props;

    const options = useMemo(() => {
        // Deep clone the default options to avoid reference sharing between instances
        const opts = JSON.parse(JSON.stringify(defaultChartLineOptions));

        if (formatting.colorStops) {
            // Create a deep copy of the colorStops array and its objects
            opts.fill.gradient.colorStops = formatting.colorStops.map(stop => ({
                ...stop
            }));
        }

        // Disable animations during resize to prevent gradual animation bug
        if (isResizing) {
            opts.chart.animations = { enabled: false };
        }

        return opts;
    }, [formatting.colorStops, isResizing]);

    return <Chart type="line" height="34px" width="100%" options={options} series={dataSeries} />;
}

export const defaultChartLineOptions = {
    chart: {
        type: "line",
        //width: 160,
        height: 28,
        sparkline: { enabled: true },
        stacked: false,
        // Add padding to prevent edge points from being clipped
        offsetX: 0,
        offsetY: 0,
        // Disable automatic resize to prevent gradual animation bug
        redrawOnWindowResize: false,
        redrawOnParentResize: false
    },
    stroke: { curve: "smooth", width: 3 },
    fill: {
        type: "gradient",
        gradient: {
            opacityFrom: 1,
            opacityTo: 1,
            colorStops: [
                { offset: 0, color: "#1E2631", opacity: 1 },
                { offset: 100, color: "#00BB00", opacity: 1 }
            ]
        }
    },
    // Add grid padding to prevent clipping of the last point
    grid: {
        padding: {
            right: 5,
            left: 5
        }
    },
    //labels: ["Jun 23", "Jun 24", "Jun 25", "Jun 26", "Jun 27", "Jun 28", "Jun 29"],
    xaxis: {
        crosshairs: { width: 1 },
        // Add slight padding to x-axis range to prevent last point clipping
        axisBorder: { show: false },
        axisTicks: { show: false }
    },
    tooltip: {
        theme: "dark",
        fixed: { enabled: false },
        x: { show: false },
        y: {
            title: {
                formatter: function (seriesName) {
                    return "";
                }
            },
            formatter: value => {
                return convertNumberWithCommas(value);
            }
        },
        marker: { show: false }
    }
    /*responsive: [
        { breakpoint: 3000, options: { chart: { width: 120 } } },
        { breakpoint: 1300, options: { chart: { width: 100 } } },
        { breakpoint: 1200, options: { chart: { width: 160 } } },
        { breakpoint: 900, options: { chart: { width: 120 } } },
        { breakpoint: 576, options: { chart: { width: 180 } } },
        { breakpoint: 400, options: { chart: { width: 120 } } }
    ]*/
};

export const convertNumberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
